// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__vgjCL","title":"AfterFrontImage_title__2gCRj"};